import React, { useState, useEffect } from 'react';
import { Alert, Container, Button, Card, Spinner, Form, Row, Col, ButtonGroup, Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import { getEvaluableEmployeeMonitor } from '../../redux/capacitacionDesarrollo/evaluable_employee_monitor/actions';
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

const EvaluableEmployeeMonitor = () => {

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState({ name: 'empresa', desc: "Empresa" });
  const [filterValue, setFilterValue] = useState('');
  const [filterType, setFilterType] = useState('');

  const onShowSidebar = () => setShow(show ? false : true);

  const history = useHistory();
  const dispatch = useDispatch();
  
  const { evaluableEmployeesMonitor, isLoading, error, count } = useSelector(store => store.evaluableEmployeeMonitor);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const pages = Math.ceil(count / limit);
  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Capacitación",
      accessor: "capacitacion",
    },
    {
      Header: "Fecha de Capacitación",
      accessor: "fecha_capacitacion",
    },
    {
      Header: "Nota de Evaluación",
      accessor: "nota_evaluacion",
    },
    {
      Header: "Desempeño",
      accessor: "desempeno",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => history.push(`/capacitacion-desarrollo/formato-evaluacion-capacitacion/${value.row.original.detalle_evento_id}/${value.row.original.empleado_id}`)}>
            <i className="material-icons">assignment</i>
          </Button>
        </div>
      ),
    },
  ];
  
  const filters = [
    { name: 'empresa', desc: "Empresa",  authorized_roles: ["administrador"] },
    { name: 'zona', desc: "Zona" },
    { name: 'centro_costo', desc: "Centro de costo" },
    { name: 'responsable', desc: "Responsable" },
    { name: 'estado', desc: "Estado" },
    { name: 'codigo', desc: "Código" },
    { name: 'nombre', desc: "Nombre" },
    { name: 'asistencia', desc: "Asistencia" },
  ]

  const getEvaluableEmployeeMonitorData = (offs = offset, lim = limit, filter=filterValue, tipo_busqueda=filterType) => {
    const filters = {
      offset: offs,
      limit: lim
    }
    if (filter) {
      filters.filter = filter;
    }
    if (tipo_busqueda) {
      filters.tipo_busqueda = tipo_busqueda;
    }
    dispatch(getEvaluableEmployeeMonitor(filters));
  }
  useEffect(() => {
    getEvaluableEmployeeMonitorData(); 
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    const filter = e.target.filter.value;
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getEvaluableEmployeeMonitorData(oOffset, limit, filter, tipoBusqueda.name);
    setFilterValue(filter);
    setFilterType(tipoBusqueda.name);
    //dispatch(getEvaluableEmployeeMonitor({tipo_busqueda: tipoBusqueda.name, filter})); 
  }
  
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Monitor de empleados evaluables</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                      {filters.map((item) => {
                        const tieneAcceso = !item.authorized_roles || item.authorized_roles.some(rol => userRoles.includes(rol));

                        return tieneAcceso ? (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ) : null;
                      })}
                    </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {
            error && (
              <Alert variant="danger" className="my-4"><b>Error:</b> {error}</Alert>
            )
          }
          {
            isLoading ? ( 
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : evaluableEmployeesMonitor.length > 0 ? (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={evaluableEmployeesMonitor} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={count}
                  pages={pages}
                  pagFunc={getEvaluableEmployeeMonitorData}
                />
              </>
            ) : (
              <Alert variant="info" className="my-4">
                No se encontraron registros
              </Alert>
            )
          }
        </Container>
      </div>
    </>
  )
}

export default EvaluableEmployeeMonitor